import { useEffect, useState } from 'react';
import { useI18n } from '../i18n';
import type { ModeKey } from '../router';

function read(mode: string) {
  try {
    const v = localStorage.getItem(`geodle:endless:${mode}`);
    const s = v ? JSON.parse(v) : null;
    return { solved: s?.solved ?? 0, streak: s?.streak ?? 0, best: s?.best ?? 0 };
  } catch {
    return { solved: 0, streak: 0, best: 0 };
  }
}

// Unlimited 会话统计条:Solved / Streak / Best(随 geodle:endless 事件刷新)
export default function EndlessBar({ mode }: { mode: ModeKey }) {
  const { t } = useI18n();
  const [s, setS] = useState(() => read(mode));
  useEffect(() => {
    setS(read(mode));
    const h = () => setS(read(mode));
    window.addEventListener('geodle:endless', h);
    return () => window.removeEventListener('geodle:endless', h);
  }, [mode]);

  return (
    <div className="daily-strip">
      <div className="ledger">
        <div className="ds-item">
          <span className="ds-k ds-badge">{t.unlimited}</span>
        </div>
        <div className="ds-item">
          <span className="ds-k">{t.solved}</span>
          <span className="ds-v">{s.solved}</span>
        </div>
        <div className="ds-item">
          <span className="ds-k">{t.streak}</span>
          <span className="ds-v">{s.streak}</span>
        </div>
        <div className="ds-item">
          <span className="ds-k">{t.best}</span>
          <span className="ds-v">{s.best}</span>
        </div>
      </div>
    </div>
  );
}
